import { parseMultiValueFilter } from '@openx/utils/lib/multiValueFilter.ts';
import { useCallback, useEffect, useState } from 'react';

export interface DealsMoreFiltersRememberedValuesController {
  rememberedValues: string[];
  rememberValue: (value: string) => void;
  clearRememberedValues: () => void;
}

export const useDealsMoreFiltersRememberedValues = (
  appliedValue?: string
): DealsMoreFiltersRememberedValuesController => {
  const [rememberedValues, setRememberedValues] = useState<string[]>(() => parseMultiValueFilter(appliedValue));

  useEffect(() => {
    if (!appliedValue) {
      return;
    }

    const nextValues = parseMultiValueFilter(appliedValue);
    setRememberedValues(currentValues => {
      const merged = [...currentValues];
      for (const nextValue of nextValues) {
        if (!merged.includes(nextValue)) {
          merged.push(nextValue);
        }
      }
      return merged;
    });
  }, [appliedValue]);

  const rememberValue = useCallback((value: string) => {
    setRememberedValues(currentValues => (currentValues.includes(value) ? currentValues : [...currentValues, value]));
  }, []);

  const clearRememberedValues = useCallback(() => {
    setRememberedValues([]);
  }, []);

  return {
    rememberedValues,
    rememberValue,
    clearRememberedValues,
  };
};
